<template>
    <form-generator
        v-model="reactiveValue"
        :schema="formSchema"
        value-class=""
    ></form-generator>
</template>

<script>
import HocFormGenerator from '@/components/FormGenerator/HocFormGenerator';
import FormLayout from '@/components/FormLayout/VerticalFormLayout';
import { checkMacAddress } from '@/common/validationRules';
import { mapState } from 'vuex';
import { sortBy } from 'lodash';

const FormGenerator = HocFormGenerator(FormLayout);

export default {
    name: 'DeviceEditForm',
    components: {
        'form-generator': FormGenerator
    },
    props: {
        value: {
            type: Object,
            required: false,
            default: () => {}
        },
        deviceDetailsLoading: {
            type: Boolean,
            default: false
        },
        hasServiceAccount: {
            type: Boolean,
            default: false
        },
        channelOptions: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapState('device', ['makeOptions', 'modelOptions']),
        ...mapState('spaces', ['allSpaces']),
        ...mapState('tags', ['deviceTags']),
        reactiveValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        },
        tagsOptions() {
            return sortBy(this.deviceTags, 'name');
        },
        formSchema() {
            return [
                {
                    name: 'name',
                    hideLabel: true,
                    component: {
                        type: 'v-text-field',
                        props: {
                            label: 'Name *',
                            dense: true,
                            required: true,
                            maxlength: 300
                        }
                    }
                },
                {
                    name: 'make',
                    hideLabel: true,
                    component: {
                        type: 'v-autocomplete',
                        props: {
                            label: 'Make *',
                            dense: true,
                            required: true,
                            disabled: this.hasServiceAccount,
                            items: this.makeOptions
                        }
                    }
                },
                {
                    name: 'model',
                    hideLabel: true,
                    component: {
                        type: 'v-autocomplete',
                        props: {
                            label: 'Model *',
                            dense: true,
                            required: true,
                            itemText: item => `${item.name} - (${item.type})`,
                            itemValue: 'name',
                            disabled: this.hasServiceAccount,
                            items: this.modelOptions
                        }
                    }
                },
                {
                    name: 'hostMac',
                    hideLabel: true,
                    component: {
                        type: 'v-text-field',
                        props: {
                            label: 'Host Mac *',
                            dense: true,
                            required: true,
                            maxlength: 17,
                            disabled: this.hasServiceAccount,
                            mask: 'FF:FF:FF:FF:FF:FF',
                            rules: [v => checkMacAddress(v, 'Host Mac')]
                        }
                    }
                },
                {
                    name: 'serialNumber',
                    hideLabel: true,
                    component: {
                        type: 'v-text-field',
                        props: {
                            label: 'Serial Number *',
                            required: true,
                            dense: true,
                            disabled: this.hasServiceAccount,
                            maxlength: 15,
                            mask: 'XXXXXXXXXXXXXXX'
                        }
                    }
                },
                {
                    name: 'defaultChannel',
                    hideLabel: true,
                    component: {
                        type: 'v-select',
                        props: {
                            label: 'Default Channel',
                            dense: true,
                            itemText: v =>
                                `${v.channelNumber} - ${v.onScreenCallsign}`,
                            returnObject: true,
                            itemValue: 'channelNumber',
                            items: this.channelOptions
                        }
                    }
                },
                {
                    name: 'tags',
                    hideLabel: true,
                    component: {
                        type: 'v-autocomplete',
                        props: {
                            label: 'Tags',
                            dense: true,
                            multiple: true,
                            smallChips: true,
                            deletableChips: true,
                            hideSelected: true,
                            itemText: 'name',
                            returnObject: true,
                            items: this.tagsOptions
                        }
                    }
                }
            ];
        }
    }
};
</script>

<style></style>
